import { Paths } from './paths';
export const ALL_REFERRERS = [{
  referrerType: 'internal',
  location: {
    pathname: Paths.AGENTS
  },
  productType: 'AGENT',
  referrers: ['breeze', 'breeze-intro', 'breeze-agents', 'breeze-assistants']
}];